<div class="flex w-md flex-col gap-4 rounded-md bg-primary-purple-light-2 p-4 shadow">
  <div class="flex justify-between items-center">
    <h2 class="text-lg font-bold text-primary-purple">{{ literalService.get('vehicles.actions.timelineConfig.title', true) }}</h2>
    <img [src]="images.close" class="w-5 h-5 cursor-pointer" (click)="close()" />
  </div>
  <div class="flex flex-col gap-8">
    <div class="flex flex-col gap-4">
      @if (isWeekMode()) {
        <div class="flex flex-col gap-2">
          <span class="text-base font-semibold text-primary-purple">{{ literalService.get('vehicles.actions.timelineConfig.visibleDays', true) }}</span>
          <div class="grid grid-cols-7 gap-2">
            @for (day of days; track day) {
              <button
                type="button"
                class="btn btn-xs rounded! border h-7!"
                [ngClass]="chipClass(isDaySelected(day))"
                [disabled]="isLastDaySelected(day)"
                (click)="toggleDay(day)"
              >
                {{ dayLabel(day) }}
              </button>
            }
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <span class="text-base font-semibold text-primary-purple">{{ literalService.get('vehicles.actions.timelineConfig.quickSelection', true) }}</span>
          <div class="flex flex-wrap gap-1.5">
            @for (preset of dayPresets; track preset) {
              <button
                type="button"
                class="btn btn-sm rounded-lg! border h-7! px-2.5! py-1!"
                [ngClass]="chipClass(activeDayPreset() === preset)"
                (click)="selectDayPreset(preset)"
              >
                {{ literalService.get('vehicles.actions.timelineConfig.' + preset, true) }}
              </button>
            }
          </div>
        </div>
        <div class="divider m-0 h-1"></div>
      }
      <div class="flex flex-col gap-2">
        <span class="text-base font-semibold text-primary-purple">{{ literalService.get('vehicles.actions.timelineConfig.visibleHours', true) }}</span>
        <div class="grid grid-cols-5 gap-2">
          @for (hour of hours; track hour) {
            <button
              type="button"
              class="btn btn-xs rounded! border h-7!"
              [ngClass]="chipClass(isSelected(hour))"
              [disabled]="isLastSelected(hour)"
              (click)="toggleHour(hour)"
            >
              {{ hourLabel(hour) }}
            </button>
          }
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <span class="text-base font-semibold text-primary-purple">{{ literalService.get('vehicles.actions.timelineConfig.quickSelection', true) }}</span>
        <div class="flex flex-wrap gap-1.5">
          @for (preset of presets; track preset) {
            <button
              type="button"
              class="btn btn-sm rounded-lg! border h-7! px-2.5! py-1!"
              [ngClass]="chipClass(activePreset() === preset)"
              (click)="selectPreset(preset)"
            >
              {{ literalService.get('vehicles.actions.timelineConfig.' + preset, true) }}
            </button>
          }
        </div>
      </div>
    </div>
    <div class="flex justify-between gap-6">
      <input
        type="button"
        class="secondary h-10 w-full cursor-pointer border-2 font-semibold uppercase"
        [value]="literalService.get('cancel', true)"
        (click)="close()"
      />
      <input
        type="button"
        class="primary h-10 w-full cursor-pointer border-2 font-semibold uppercase text-white"
        [value]="literalService.get('apply', true)"
        [disabled]="!changed()"
        (click)="apply()"
      />
    </div>
  </div>
</div>
